// src/authConfig.js
import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_B2C_CLIENT_ID,
    authority:
      process.env.REACT_APP_B2C_AUTHORITY_URL + process.env.REACT_APP_B2C_SUSI_FLOW,
    knownAuthorities: [process.env.REACT_APP_B2C_AUTHORITY_DOMAIN],
    redirectUri: (process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000") + "/login",
    postLogoutRedirectUri: (process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000") + "/login",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowRedirectInIframe: true,
  },
};

export const b2cPolicies = {
  names: {
    signUpSignIn: process.env.REACT_APP_B2C_SUSI_FLOW,
    resetPassword: process.env.REACT_APP_B2C_PASSWORD_RESET_FLOW,
  },
  authorities: {
    signUpSignIn: {
      authority:
        process.env.REACT_APP_B2C_AUTHORITY_URL + process.env.REACT_APP_B2C_SUSI_FLOW,
    },
    resetPassword: {
      authority:
        process.env.REACT_APP_B2C_AUTHORITY_URL + process.env.REACT_APP_B2C_PASSWORD_RESET_FLOW,
    },
  },
  authorityDomain: process.env.REACT_APP_B2C_AUTHORITY_DOMAIN,
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "offline_access",
    process.env.REACT_APP_B2C_API_SCOPE,
  ],
};

export const msalInstance = new PublicClientApplication(msalConfig);
